import type { VisibilityState } from "@tanstack/react-table";
import type { Server } from "@/app/servers/types";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import { serverColumns } from "./columns";

type ServersTableProps = {
  items: Server[];
  stickyColumnBg?: "card" | "background";
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (
    updater: VisibilityState | ((old: VisibilityState) => VisibilityState)
  ) => void;
};

export const ServersTable = ({
  items,
  stickyColumnBg = "background",
  columnVisibility,
  onColumnVisibilityChange,
}: ServersTableProps) => (
  <DataTable
    className="space-y-4"
    columns={serverColumns}
    columnVisibility={columnVisibility}
    data={items}
    defaultPageSize={5}
    onColumnVisibilityChange={onColumnVisibilityChange}
  >
    <DataTableContent stickyColumnBg={stickyColumnBg} />
    <DataTablePagination />
  </DataTable>
);
